import Button from '@/components/quasar-overrides/CoreButton.vue';
import Select from '@/components/quasar-overrides/CoreSelect.vue';
import InnerLoader from '@/components/core/InnerLoader.vue';
import DateInput from '@/components/core/date-input/DateInput.vue';
import TimeDuration from '@/components/core/TimeDuration.vue';
import ButtonToggle from '@/components/core/ButtonToggle.vue';
import DialogCloseIcon from '@/components/core/icons/DialogCloseIcon.vue';
import Octicon from '@/components/core/icons/Octicon.vue';
import FluentIcon from '@/components/core/icons/FluentIcon.vue';
import CustomIcon from '@/components/core/icons/CustomIcon.vue';
import draggable from 'vuedraggable';
import AlertMessage from '@/components/core/AlertMessage.vue';
import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  DoughnutController,
  LinearScale,
  LineController,
  LineElement,
  PieController,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import DataChart from '@/components/core/DataChart.vue';
import { App } from 'vue';

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  BarElement,
  BarController,
  CategoryScale,
  Tooltip,
  DoughnutController,
  PieController,
  ArcElement
);

// Configure charts to show values even when not hovering
(Chart.defaults.font as unknown as { family: string }).family =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";

export default (app: App) => {
  {
    // eslint-disable-next-line vue/multi-word-component-names
    app.component('Draggable', draggable);
    app.component('PBtn', Button);
    app.component('DsSelect', Select);
    app.component('DsAlertMessage', AlertMessage);
    app.component('PInnerLoader', InnerLoader);
    app.component('PDateInput', DateInput);
    app.component('DsTimeDuration', TimeDuration);
    app.component('PDialogCloseIcon', DialogCloseIcon);
    app.component('ChartJs', DataChart);
    // eslint-disable-next-line vue/multi-word-component-names
    app.component('Octicon', Octicon);
    app.component('FluentIcon', FluentIcon);
    app.component('CustomIcon', CustomIcon);
    app.component('DsButtonToggle', ButtonToggle);
    if (import.meta.env.MODE === 'test')
      app.directive('test-id', (el, { value }) =>
        el.setAttribute('data-test-id', value)
      );
    else app.directive('test-id', {});
  }
};

declare module 'vue' {
  export interface GlobalComponents {
    Draggable: typeof draggable;
    PBtn: typeof Button;
    DsSelect: typeof Select;
    DsAlertMessage: typeof AlertMessage;
    PInnerLoader: typeof InnerLoader;
    PDateInput: typeof DateInput;
    DsTimeDuration: typeof TimeDuration;
    PDialogCloseIcon: typeof DialogCloseIcon;
    ChartJs: typeof DataChart;
    Octicon: typeof Octicon;
    FluentIcon: typeof FluentIcon;
    CustomIcon: typeof CustomIcon;
    DsButtonToggle: typeof ButtonToggle;

    // quasar components
    QInput: typeof import('quasar')['QInput'];
    QDialog: typeof import('quasar')['QDialog'];
    QItemSection: typeof import('quasar')['QItemSection'];
    QMarkupTable: typeof import('quasar')['QMarkupTable'];
    QSkeleton: typeof import('quasar')['QSkeleton'];
    QTooltip: typeof import('quasar')['QTooltip'];
    QRadio: typeof import('quasar')['QRadio'];
    QBadge: typeof import('quasar')['QBadge'];
    QItem: typeof import('quasar')['QItem'];
    QPopupProxy: typeof import('quasar')['QPopupProxy'];
    QList: typeof import('quasar')['QList'];
    QAvatar: typeof import('quasar')['QAvatar'];
    QSeparator: typeof import('quasar')['QSeparator'];
    QBtnDropdown: typeof import('quasar')['QBtnDropdown'];
    QForm: typeof import('quasar')['QForm'];
    QMenu: typeof import('quasar')['QMenu'];
    QCheckbox: typeof import('quasar')['QCheckbox'];
    QToggle: typeof import('quasar')['QToggle'];
    QDate: typeof import('quasar')['QDate'];
    QSpinner: typeof import('quasar')['QSpinner'];
    QIcon: typeof import('quasar')['QIcon'];
    QBtn: typeof import('quasar')['QBtn'];
    QIntersection: typeof import('quasar')['QIntersection'];
    QUploader: typeof import('quasar')['QUploader'];
    QUploaderAddTrigger: typeof import('quasar')['QUploaderAddTrigger'];
    QFile: typeof import('quasar')['QFile'];
    QTabPanels: typeof import('quasar')['QTabPanels'];
    QTabPanel: typeof import('quasar')['QTabPanel'];
    QCircularProgress: typeof import('quasar')['QCircularProgress'];
    QSelect: typeof import('quasar')['QSelect'];
    QTabs: typeof import('quasar')['QTabs'];
    QTab: typeof import('quasar')['QTab'];
    QTd: typeof import('quasar')['QTd'];
    QCard: typeof import('quasar')['QCard'];
    QCardSection: typeof import('quasar')['QCardSection'];

    // Vue Router
    RouterLink: typeof import('vue-router')['RouterLink'];
    RouterView: typeof import('vue-router')['RouterView'];
  }
}
